/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Dl_Linux_S3Inputs */

const en_fc_dl_linux_s3 = /** @type {(inputs: Fc_Dl_Linux_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Debian / Ubuntu use the .deb, Fedora / openSUSE the .rpm, and Arch Linux the .pkg.tar.zst. RISC-V boards get .deb, .rpm and a tarball.`)
};

/**
* | output |
* | --- |
* | "Debian / Ubuntu use the .deb, Fedora / openSUSE the .rpm, and Arch Linux the .pkg.tar.zst. RISC-V boards get .deb, .rpm and a tarball." |
*
* @param {Fc_Dl_Linux_S3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_dl_linux_s3 = /** @type {((inputs?: Fc_Dl_Linux_S3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Dl_Linux_S3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_dl_linux_s3(inputs)
});
export { fc_dl_linux_s3 as "fc.dl.linux.s3" }